import React from "react";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import HeroSection from './components/Home/HeroSection';
import IsthisForYou from "./components/Home/IsthisForYou";
import ServiceSection from "./components/Home/ServiceSection";
import GDeskWork from "./components/Home/GDeskWork";
import AboutUs from "./components/Home/AboutUs";
import FAQ from "./components/Home/FAQ";
import Outro from "./components/Home/Outro";

function App() {
  return (
    <div className="App text-primary">
      
      <Navbar />
      
      {/* Sections */}
      <HeroSection/>

      <IsthisForYou/>

      <ServiceSection/>

      <GDeskWork/>

      <AboutUs/>
      
      <FAQ/>

      <Outro/>

      <Footer/>
    </div>
  );
}

export default App;
